<template>
  <div class="row selected-item">
    <div class="col-7">
      {{ item.stockCode }} - {{ item.title }}
        <addToCartButton
          ref="add_cart_button"
          :data="{}"
          label_added_to_cart="added_to_cart"
          label_add_to_cart="add_to_cart"
          :enable_b2c="enable_b2c"
          :enable_b2b="enable_b2b"
          label_adding_to_cart="label_adding_to_cart"
          label_view_cart="label_view_cart"
          label_continue_shopping="label_continue_shopping"
          :netsuite_url="netsuite_url"
          :netsuite_app_url="netsuite_app_url"
          v-show="0"
        ></addToCartButton>
    </div>
    <div class="col-4">
      <input
        v-model="item.qty"
        v-on:change="itemUpdated(item, $event)"
        type="number"
        placeholder="Qty" />
    </div>
    <div>
      <span class="icon icon-close" @click="$emit('on-delete')" style="cursor:pointer"></span>
    </div>
  </div>
</template>

<script>
import addToCartButton from "../wish-list/add-to-cart.vue";
import { isNumber } from 'util';
export default {
  data() {
    return {
    }
  },
  components: {
    addToCartButton
  },
  props: {
    item: Object,
    enable_b2c: {},
    enable_b2b: {},
    netsuite_url: {},
    netsuite_app_url: {},
  },
  methods: {
    addToCartEvent(item) {

      this.$refs.add_cart_button.data.stockCode = item.stockCode;
      this.$refs.add_cart_button.data.netSuiteId = item.netsuiteId;
      this.$refs.add_cart_button.data.netSuiteParentId = item.netSuiteParentId;
      this.$refs.add_cart_button.data.productId = item.productId;
      this.$refs.add_cart_button.data.quantity = item.qty;

      this.$refs.add_cart_button.addToCartWishList();
    },
    itemUpdated(item, $event) {
      if (item.qty == '' || item.qty == 0 || !isNumber(Number(this.qty))) {
        item.qty = 1;
        $event.srcElement.value = 1
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.completed {
  text-decoration: line-through;
}
</style>
